module.exports = __webpack_public_path__ + "img/img1.156d41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img1.png
// module id = 274
// module chunks = 0